import { AiArtifact, APIMessage, mapApiMessageToMessage, Message } from './message';

export type ToolCall = {
  tool_name: string;

  args?: string | Record<string, any>;

  tool_call_id: string;
  id?: string;

  provider_details?: Record<string, any>;
};

export type ToolReturn = {
  return_value: any;
};

export type DeferredToolRequests = {
  approvals: Array<ToolCall>;
  calls: Array<ToolCall>;
  metadata: Record<string, Record<string, any>>;
};

export type DeferredToolResults = {
  approvals?: Record<string, boolean>;
  calls?: Record<string, ToolReturn>;
};

export type ApiChatResponse = {
  message: APIMessage;
  session_id: string;
  artifacts: AiArtifact;
  interruption: boolean;
  deferred_tool_requests?: DeferredToolRequests;
};

export type ChatResponse = {
  message: Message;
  sessionId: string;
  artifacts: AiArtifact;
  interruption: boolean;
  deferredToolRequests?: DeferredToolRequests;
};

export function mapApiChatResponseToChatResponse(response: ApiChatResponse): ChatResponse {
  return {
    message: mapApiMessageToMessage(response.message),
    sessionId: response.session_id,
    artifacts: response.artifacts,
    interruption: response.interruption,
    deferredToolRequests: response.deferred_tool_requests,
  };
}
